module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_19-6bd3247915f68a28e5017f1b1bdbb35f.jpg";